'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var multicodec = require('multicodec');

var nameToCodec = function nameToCodec(name) {
  return multicodec[name.toUpperCase().replace(/-/g, '_')];
};

module.exports = function (_ref) {
  var ipld = _ref.ipld,
      pin = _ref.pin,
      gcLock = _ref.gcLock,
      preload = _ref.preload;
  return /*#__PURE__*/function () {
    var _put = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dagNode, options) {
      var optionDefaults, release, cid;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = options || {};

              if (!(options.cid && (options.format || options.hashAlg))) {
                _context.next = 5;
                break;
              }

              throw new Error('Can\'t put dag node. Please provide either `cid` OR `format` and `hashAlg` options.');

            case 5:
              if (!(options.format && !options.hashAlg || !options.format && options.hashAlg)) {
                _context.next = 7;
                break;
              }

              throw new Error('Can\'t put dag node. Please provide `format` AND `hashAlg` options.');

            case 7:
              optionDefaults = {
                format: multicodec.DAG_CBOR,
                hashAlg: multicodec.SHA2_256
              }; // The IPLD expects the format and hashAlg as constants

              if (options.format && typeof options.format === 'string') {
                options.format = nameToCodec(options.format);
              }

              if (options.hashAlg && typeof options.hashAlg === 'string') {
                options.hashAlg = nameToCodec(options.hashAlg);
              }

              options = options.cid ? options : Object.assign({}, optionDefaults, options); // js-ipld defaults to verion 1 CIDs. Hence set version 0 explicitly for
              // dag-pb nodes

              if (options.version === undefined) {
                if (options.format === multicodec.DAG_PB && options.hashAlg === multicodec.SHA2_256) {
                  options.version = 0;
                } else {
                  options.version = 1;
                }
              }

              if (!options.pin) {
                _context.next = 16;
                break;
              }

              _context.next = 15;
              return gcLock.readLock();

            case 15:
              release = _context.sent;

            case 16:
              _context.prev = 16;
              _context.next = 19;
              return ipld.put(dagNode, options.format, {
                hashAlg: options.hashAlg,
                cidVersion: options.version
              });

            case 19:
              cid = _context.sent;

              if (!options.pin) {
                _context.next = 23;
                break;
              }

              _context.next = 23;
              return pin.add(cid, {
                lock: false
              });

            case 23:
              if (options.preload !== false) {
                preload(cid);
              }

              return _context.abrupt("return", cid);

            case 25:
              _context.prev = 25;

              if (release) {
                release();
              }

              return _context.finish(25);

            case 28:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[16,, 25, 28]]);
    }));

    function put(_x, _x2) {
      return _put.apply(this, arguments);
    }

    return put;
  }();
};